import { defineComponent as h, computed as l, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ t("mask", { id: "4ce45e2b-2d53-401b-a22e-b89652ec99c3" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#4ce45e2b-2d53-401b-a22e-b89652ec99c3)" }, u = { key: 0 }, k = /* @__PURE__ */ p('<path fill="#ffda44" d="M0 85v342l256 31 256-31V85L256 53Z"></path><path fill="#333" d="M0 0h512v85H0z"></path><path fill="#d80027" d="M0 171h512v85l-256 31L0 256Z"></path><path fill="#333" d="M0 256h512v85H0z"></path><path fill="#d80027" d="M0 427h512v85H0z"></path><circle cx="256" cy="256" r="85.3" fill="#eee"></circle><path fill="#333" d="m287 260-31-13 8-26a17 17 0 0 0-5-16l8-8a28 28 0 0 0-19-8 28 28 0 0 0-20 8l8 8a17 17 0 0 0-5 12l1 5-12 12h21s-9 13-14 24c-4 11 0 25 12 30l6 2 11 10v12l-11 11h22v-23l10-10h21a22 22 0 0 0-11-30z"></path>', 7), g = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ h({
  __name: "ug",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      v,
      t("g", m, [
        e.flagName ? (c(), i("title", u, d(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  z as default
};
//# sourceMappingURL=ug-3119b8bc.js.map
